module.exports = require("@swa-ui/dotcom/src/placements/DestinationByThemePlacement/DestinationByThemeCard/DestinationByThemeCard.module.scss");